import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Loader } from '$components/loader/loader';
import type { SidecarRouterProps } from '$components/sidecar-router/sidecar-router.definitions';
import { SidecarRouterProvider } from '$components/sidecar-router/sidecar-router-context';

export function SidecarRouter({ router }: SidecarRouterProps) {
  const [searchParams] = useSearchParams();
  const [loaderFinished, setLoaderFinished] = useState(false);
  const firstRoutePartial = searchParams.get('sidecarRoute')?.split('/')[0] ?? '';
  const loader = router[firstRoutePartial]?.loader;

  useEffect(() => {
    if (!loader) {
      setLoaderFinished(true);
      return;
    }

    async function runLoader() {
      if (loader !== undefined && firstRoutePartial) {
        await loader({
          params: searchParams,
        });
      }
    }

    setLoaderFinished(false);

    runLoader()
      .catch((error) => {
        // eslint-disable-next-line no-console -- we want to have errors thrown here
        console.error('Sidecar Loader error:', error);
      })
      .finally(() => {
        setLoaderFinished(true);
      });
  }, [searchParams, firstRoutePartial, loader]);

  return (
    <SidecarRouterProvider value={{ route: router[firstRoutePartial] }}>
      {!loaderFinished ? <Loader /> : <span />}
      {loaderFinished && router[firstRoutePartial]?.element}
    </SidecarRouterProvider>
  );
}
